export const sendGridEventTypes = {
  delivered: "success",
  processed: "info",
  open: "warning",
  bounce: "danger",
  deferred: "danger",
  dropped: "danger",
  click: "primary"
};
